<template>
  <div>
    <div
      class="bg-fixed"
      :class="{'bg_i6_tp': isThaiCharoenPlus, 'bg_i6_sc': isSevenColor, 'bg_i6_ts': isThaisiam, 'bg_i6_hp': isHuaypromt, 'bg_i6_jj': isJertjarat, 'bg_i6_ls': isLottoslot88, 'bg_i6_cc': isChokCharoen, 'bg_i6_bc': isBooncharern, 'bg_i6_cci': isCherdchai, 'bg_i6_scr': isSapcharern, 'bg_i6_pa': isPacharern, 'bg_i6': isDefaultSite}"
    ></div>
    <div class="py-5">
      <div class="container">
        <div
          class="row justify-center align-items-center position-relative"
          style="z-index: 1"
        >
          <LogoHeader />
        </div>

        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <h1
              class="text-center t-medium animateMe animated fadeInUp theme-main-text"
              data-animation="fadeInUp"
            >
              สมัครสมาชิก
            </h1>

            <div
              class="text-center t-medium animateMe animated fadeInUp theme-main-text"
              data-animation="fadeInUp"
            >
              ผู้ดูแลของคุณคือ {{ agent_first_name || agent_username }}
            </div>

            <h5
              class="text-center mt-4 animateMe animated fadeInUp theme-main-text"
              data-animation="fadeInUp"
            >
              ลงทะเบียนเข้าระบบ (เบอร์โทรศัพท์)
            </h5>

            <form
              class="animateMe"
              data-animation="fadeInUp"
              @submit.prevent
            >
              <h5 class="text-center w-100 c-white my-3">
                <!-- หรือ -->
              </h5>
              <div class="box_shadow bg_c9 p-2 mt-2 bdr-10 position-relative"> 
                <input
                  v-model="$v.phoneNumber.$model"
                  type="text"
                  maxlength="10"
                  class="form-control border-0"
                  placeholder="เบอร์โทรศัพท์"
                  :disabled="!!countDown"
                  @input="onInputChange"
                >
              </div>
              <div
                v-if="$v.phoneNumber.$dirty && $v.phoneNumber.$invalid"
                class="pt-2 t-medium animateMe animated fadeInUp theme-main-text"
              >
                <div
                  v-if="!$v.phoneNumber.required"
                  class="animateMe animated fadeInUp a-v-error"
                  :class="{'a-v-error-jj': isJertjarat}"
                >
                  กรุณากรอกเบอร์โทรศัพท์
                </div>

                <div
                  v-if="!$v.phoneNumber.minLength"
                  class="animateMe animated fadeInUp a-v-error"
                  :class="{'a-v-error-jj': isJertjarat}"
                >
                  *กรุณากรอกเบอร์โทรศัพท์ 10 หลัก
                </div>
              </div>

              <div class="box_shadow bg_c9 p-2 bdr-10 position-relative mt-3 animateMe animated fadeInUp">
                <input
                  v-model="$v.new_password.$model"
                  type="password"
                  class="form-control border-0"
                  placeholder="รหัสผ่าน"
                >
              </div>

              <div
                v-if="$v.new_password.$dirty && $v.new_password.$invalid"
                class="pt-2 t-medium animateMe animated fadeInUp theme-main-text"
              >
                <div
                  v-if="!$v.new_password.required"
                  class="animateMe animated fadeInUp a-v-error"
                  :class="{'a-v-error-jj': isJertjarat}"
                >
                  กรุณากรอกรหัสผ่าน
                </div>

                <div
                  v-if="!$v.new_password.minLength"
                  class="animateMe animated fadeInUp a-v-error"
                  :class="{'a-v-error-jj': isJertjarat}"
                >
                  *รหัสผ่านควรมีความยาวมากกว่า 8 ตัวอักษร
                </div>
              </div>

              <div class="box_shadow bg_c9 p-2 bdr-10 position-relative mt-3 animateMe animated fadeInUp">
                <input
                  v-model="$v.password_confirmation.$model"
                  type="password"
                  class="form-control border-0"
                  placeholder="ยืนยันรหัสผ่าน"
                >
              </div>

              <div
                v-if="$v.password_confirmation.$dirty && $v.password_confirmation.$invalid"
                class="pt-2 t-medium animateMe animated fadeInUp theme-main-text"
              >
                <div
                  v-if="!$v.password_confirmation.required"
                  class="animateMe animated fadeInUp a-v-error"
                  :class="{'a-v-error-jj': isJertjarat}"
                >
                  กรุณากรอกยืนยันรหัสผ่าน
                </div>

                <div
                  v-if="!$v.password_confirmation.minLength"
                  class="animateMe animated fadeInUp a-v-error"
                  :class="{'a-v-error-jj': isJertjarat}"
                >
                  *รหัสผ่านควรมีความยาวมากกว่า 8 ตัวอักษร
                </div>
                <div
                  v-if="!$v.password_confirmation.sameAs"
                  class="animateMe animated fadeInUp a-v-error"
                  :class="{'a-v-error-jj': isJertjarat}"
                >
                  **รหัสผ่านไม่ตรงกัน
                </div>
              </div>

              <div class="d-flex justify-content-end mt-2 mb-3">
              </div>

              <!-- <button
                class="button-main bdr-20 bg_c2 c-white mb-3 animateMe animated fadeInUp"
                data-animation="fadeInUp"
                :disabled="$v.phoneNumber.$invalid || !!countDown"
                @click="requiredVerifyCode"
              >
                ส่ง OTP 
                <span
                  v-if="countDown"
                  class="pl-2"
                >
                  ({{ countDown }}s)
                </span>
              </button> -->

              <div v-if="state == STATE_2_AFTER_REQUEST_OTP">
                <div
                  class="line-between my-4 animateMe"
                  data-animation="fadeInUp"
                ></div>

                <div
                  class="text-center t-medium animateMe animated fadeInUp theme-main-text"
                  data-animation="fadeInUp"
                >
                  ข้อมูลธนาคาร
                </div>

                <div class="box_shadow bg_c9 p-2 bdr-10 position-relative mt-3 animateMe animated fadeInUp">
                  <v-select
                    v-model="bank_type_id"
                    dense
                    outlined
                    item-text="name"
                    item-value="id"
                    :items="bankList"
                    hide-details="auto"
                    :label="!bank_type_id ? $t('label.bank') : ''"
                    class="no-outline"
                  >
                    <template v-slot:selection="{ item }">
                      <div class="flex bank-item">
                        <v-img 
                          max-width="24" 
                          max-height="24" 
                          :src="bankIconPath(item.id)"
                        >
                        </v-img>
                        <span>{{ item.name }}</span>
                      </div>
                    </template>

                    <template v-slot:item="{ props: itemProps, item }">
                      <div class="flex bank-item">
                        <v-img 
                          max-width="24" 
                          max-height="24" 
                          :src="bankIconPath(item.id)"
                        >
                        </v-img>
                        <span>{{ item.name }}</span>
                      </div>
                    </template>
                  </v-select>
                </div>

                <div
                  v-if="$v.bank_type_id.$dirty && $v.bank_type_id.$invalid"
                  class="pt-2 t-medium animateMe animated fadeInUp theme-main-text"
                >
                  <div
                    v-if="!$v.bank_type_id.required"
                    class="animateMe animated fadeInUp a-v-error"
                    :class="{'a-v-error-jj': isJertjarat}"
                  >
                    กรุณาเลือกธนาคาร
                  </div>
                </div>

                <div class="box_shadow bg_c9 p-2 bdr-10 mt-2 position-relative animateMe animated fadeInUp">
                  <input
                    v-model="$v.bank_number.$model"
                    type="text"
                    maxlength="15"
                    class="form-control border-0"
                    placeholder="เลขบัญชี"
                    @input="onBankNumberChange"
                  >
                </div>

                <div
                  v-if="$v.bank_number.$dirty && $v.bank_number.$invalid"
                  class="pt-2 t-medium animateMe animated fadeInUp theme-main-text"
                >
                  <div
                    v-if="!$v.bank_number.required"
                    class="animateMe animated fadeInUp a-v-error"
                    :class="{'a-v-error-jj': isJertjarat}"
                  >
                    กรุณากรอกเลขบัญชี
                  </div>

                  <div
                    v-if="!$v.bank_number.minLength || !$v.bank_number.maxLength"
                    class="animateMe animated fadeInUp a-v-error"
                    :class="{'a-v-error-jj': isJertjarat}"
                  >
                    *เลขบัญชีควรมีความยาว 10-15 ตัว
                  </div>
                </div>

                <div class="box_shadow bg_c9 p-2 bdr-10 position-relative mt-3 animateMe animated fadeInUp">
                  <input
                    v-model="$v.bank_name.$model"
                    type="text"
                    class="form-control border-0"
                    placeholder="ชื่อเจ้าของบัญชี"
                  >
                </div>

                <div
                  v-if="$v.bank_name.$dirty && $v.bank_name.$invalid"
                  class="pt-2 t-medium animateMe animated fadeInUp theme-main-text"
                >
                  <div
                    v-if="!$v.bank_name.required"
                    class="animateMe animated fadeInUp a-v-error"
                    :class="{'a-v-error-jj': isJertjarat}"
                  >
                    กรุณากรอกชื่อเจ้าของบัญชี
                  </div>

                  <div
                    v-if="!$v.bank_name.minLength"
                    class="animateMe animated fadeInUp a-v-error"
                    :class="{'a-v-error-jj': isJertjarat}"
                  >
                    *ชื่อเจ้าของบัญชีควรมีความยาว 10 ตัวขึ้นไป
                  </div>
                </div>

                <router-link
                  :to="{ name: ROUTE_V3_PAYRATE }"
                  class="button-main bdr-10 bg_c17 mt-3 mt-md-5 box_shadow animateMe animated fadeInUp"
                  style="height: auto;"
                >
                  <div class="">
                    <h5 class="c-white">
                      อัตราจ่าย สูงสุดบาทละ 1,000
                    </h5>
                    <p
                      class="c-yellow t-light"
                      style="font-size: 16px;"
                    >
                      ดูราคาเพิ่มเติม กดที่นี่
                    </p>
                  </div>
                </router-link>

                <div class="mt-4">
                  <button
                    class="button-main bdr-20 bg_c2 c-white mb-3 animateMe animated fadeInUp"
                    :class="{'bg_c3_pa': isPacharern}"
                    data-animation="fadeInUp"
                    :disabled="onLoading"
                    @click="register"
                  >
                    <v-progress-circular
                      v-if="onLoading"
                      class="mr-2"
                      indeterminate
                      :size="20"
                      :width="2"
                    ></v-progress-circular>
                    <i class="fas fa-user-plus me-2"></i>
                    สมัครสมาชิก
                  </button>
                </div>
              </div>
              <div class="mt-4">
                <router-link
                  :to="{ name: ROUTE_INDEX }"
                  class="button-main bdr-20 bg_c14 border-0 animateMe"
                  
                  data-animation="fadeInUp"
                >
                  <i
                    class="fas fa-chevron-left me-2 theme-main-text"
                  ></i>
                  <span
                    class="theme-main-text"
                  >ย้อนกลับ</span>
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
import { validationMixin } from 'vuelidate' 
// import { VueReCaptcha } from "vue-recaptcha-v3";
import { auth as apiAuth, anonymous as apiAnonymous } from "@/apis";
import * as c from "@/const/setTimeOutConfig";
import { ROUTE_INDEX, ROUTE_V3_PAYRATE } from "@/const/route";
import { required, numeric, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import LogoHeader from '@/components/Page/LogoHeader'
import { preventUsername } from '@/utils/preventkeydown'
import { bankIconPath } from '@/plugins/mapImage' 

// Vue.use(VueReCaptcha, {
//   siteKey: process.env.VUE_APP_RE_CAPTCHA_KEY,
// });

export const STATE_1_BEFOR_REQUEST_OTP = 1;
export const STATE_2_AFTER_REQUEST_OTP = 2;

export default {
  components: {
    LogoHeader
  },
  mixins: [validationMixin],
  data () {
    return {
      c,
      ROUTE_INDEX,
      ROUTE_V3_PAYRATE,
      STATE_1_BEFOR_REQUEST_OTP,
      STATE_2_AFTER_REQUEST_OTP,
      state: STATE_2_AFTER_REQUEST_OTP,
      phoneNumber: "",
      otp: "",
      username: "",
      new_password: "",
      password_confirmation: "",
      bank_type_id: "",
      bank_number: null,
      bank_name: null,
      verify: {},
      agent_username: '',
      agent_first_name: null,
      upline_username: '',
      upline_user_uuid: '',
      mkt_ref: '',
      countDown: 0,
      bankList: [],
      onLoading: false,
    };
  },
  validations: {
    phoneNumber: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
    new_password: {
      required,
      minLength: minLength(8),
    },
    password_confirmation: {
      required,
      minLength: minLength(8),
      sameAs: sameAs(function () {
        return this.new_password
      }),
    },
    bank_number: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(15),
    },
    bank_name: {
      required,
      minLength: minLength(10),
    },
    bank_type_id: {
      required,
    },
    // username: {
    //   required,
    // },
  },
  computed: {
    agent_name () {
      return this.$route.query.agent_name;
    },
    af () {
      return this.$route.query.af
    },
  },
  async mounted () {
    this.init()
    this.loadBank()
    this.checkAndGet()
  },
  methods: {
    preventUsername,
    bankIconPath,
    onInputChange (event) {
      this.phoneNumber = event.target.value.replace(/\D/g, '');
    },
    onBankNumberChange (event) {
      this.bank_number = event.target.value.replace(/\D/g, '');
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
        }, 1000)
      }
    },

    async init () {
      const params = {}
      const agent_username = this.agent_name || localStorage.getItem('agent-name')
      
      if (agent_username) {
        params.agent_username = agent_username
      }
      
      let upline_user_uuid =this.af || localStorage.getItem('af-uuid')
      if(upline_user_uuid) {
        params.upline_user_uuid = upline_user_uuid
      }

      params.domain = window.location.host
      
      const [err, data] = await apiAnonymous.getAgentDetail(params)

       if(err) {
        return
      }
      
      if(data.upline_username){
        localStorage.setItem('upline-name',data.upline_username)  
      }
      
      if(data.agent_username) {
        localStorage.setItem('agent-name',data.agent_username) 
      }

      if(this.af) {
        localStorage.setItem('af-uuid',this.af) 
      }

      let mref = this.$route.query.mkt_ref || localStorage.getItem('mkt-ref')
      if(mref) {
        localStorage.setItem('mkt-ref',mref) 
        this.mkt_ref = mref
      }
      
      this.upline_username = data.upline_username
      this.agent_username = data.agent_username
      this.agent_first_name = data.agent_first_name
    },
    async checkAndGet (params={}) {
      this.upline_username = localStorage.getItem('upline-name') || null

      let agent_username = this.agent_name || localStorage.getItem('agent-name')
      if(agent_username){
        params.agent_username = agent_username
      }
      //set upline uuid
      this.upline_user_uuid = this.af || localStorage.getItem('af-uuid')

      if(this.upline_user_uuid) {
        params.upline_user_uuid = this.upline_user_uuid
      }

      let mref = this.$route.query.mkt_ref || localStorage.getItem('mkt-ref')
      if(mref) {
        params.mkt_ref = mref
        this.mkt_ref = mref
      }

      this.referrer = document.referrer || null
      if(this.referrer) {
        params.referrer = this.referrer
      }

      const [err] = await apiAnonymous.postClickCounter(params)
      
      if(err) {
        return
      }
    },
    async requiredVerifyCode () {

      if (this.$v.phoneNumber.$invalid) {
        return;
      }

      // const recaptcha_token = await this.$recaptcha("register").catch(() => {});

      // if (!recaptcha_token) {
      //   return;
      // }

      const params = {
        phone: this.phoneNumber,
        // recaptcha_token,
      };

      const [err, data] = await apiAuth.requestOTPRegister(params);

      if (err) {
        this.$alert("", err, "warning");
        return;
      }

      this.verify = data;
      this.state = STATE_2_AFTER_REQUEST_OTP;
      this.countDown = 15
      this.countDownTimer()
    },
    async loadBank () {
      const [err, data] = await apiAnonymous.getBankTypeList()
      
      if(err){
        return
      }
      
      this.bankList = data
    },
    async register () {

      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          const messages = this.$el.querySelectorAll('.a-v-error');
          const htmlMessage = Array.from(messages)
            .map(el => `<span style="color: red">${el.textContent.trim()}</span>`)
            .join('<br>');
          
            this.$alert('', 'กรุณากรอกข้อมูลให้ถูกต้อง', 'warning', { html: htmlMessage })
        });
        return;
      }

      this.onLoading = true

      const params = {
        uuid: this.verify.user_uuid,
        ref: this.verify.ref,
        // password: this.otp,
        username: this.phoneNumber,
        new_password: this.new_password,
        password_confirmation: this.password_confirmation,
        agent_username: this.agent_username,
        phone: this.phoneNumber,
        referrer: document.referrer || null,
        mkt_ref: this.$route.query.mkt_ref || localStorage.getItem('mkt-ref'),
        bank_type_id: this.bank_type_id,
        bank_number: this.bank_number,
        bank_name: this.bank_name,
        domain: window.location.host
      };

      if(this.af) {
        params.upline_user_uuid = this.af
      }

      const [err, data] = await apiAuth.register(params);

      if (err) {
        this.$alert("", err, "warning");
        this.onLoading = false
        return;
      }

      // const html = `
      //   <div>username: ${this.username}</div>
      //   <div style="margin-top: 4px">password: ${this.verify.phone}</div>
      //   <div style="margin-top: 12px"> ท่านสามารถตั้งรหัสผ่านได้ที่เมนู ตั้งค่าบัญชี</div>
      // `;

      // this.$alert("ท่านสามารถตั้งรหัสผ่านได้ที่เมนู ตั้งค่าบัญชี", "สมัครสมาชิกสำเร็จ", "success", {"html": html});

      localStorage.setItem("access-Token", data.access_token);

      this.$store.commit("auth/MUTATION_TOKEN", data.access_token);

      this.$store.commit("userProfile/MUTATION_ME", data);

      localStorage.removeItem('agent-name') 
      localStorage.removeItem('af-uuid') 
      localStorage.removeItem('upline-name')
      localStorage.removeItem('mkt-ref')  

      setTimeout(
        () => this.$router.push({ name: ROUTE_INDEX }).catch(() => {
          this.$router.go()
          this.onLoading = false
        }),
        c.DELAYREDIRECTPAGE
      );
    },
  },
};
</script>

<style scoped>
.button-main {
  width: 100%;
}
button:disabled {
  background: var(--v3-base-color-10);
}

.bank-item {
  gap: 10px;
  align-items: center;
}

.no-outline >>> fieldset {
  border-style: none;
}

.a-v-error {
  color: red;
  font-size: 1rem;
}

.a-v-error-jj {
  color: yellow;
}

.bg_c3_pa {
  background: linear-gradient(90deg, var(--v3-btn-login-color-20) 0%, var( --v3-btn-login-color-20-end) 100%) !important;
}
</style>
